import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo/get in line Vector White.svg'
import logoBlack from '../../assets/logo/get in line Vector Black.svg'
import './Nav.css';
import { useCart } from '../../context/CartProvider';
import ShoppingBag from '../../components/shopping_bag/ShoppingBag';
import lineSvg from '../../assets/nav-icons/Line-Red.svg'

function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNav, setShowNav] = useState(true);
  // const [categories, setCategories] = useState([]); // <-- We don't need this anymore
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { cart } = useCart();
  const cartRef = useRef(null);
  const cartIconRef = useRef(null);
  const location = useLocation();
  const isHomePage = location.pathname === '/';


  // --- We have REMOVED the fetchCategories useEffect ---

  // Toggle cart dropdown
  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  // Detect clicks outside the cart
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        isCartOpen &&
        cartRef.current && !cartRef.current.contains(event.target) &&
        cartIconRef.current && !cartIconRef.current.contains(event.target)
      ) {
        setIsCartOpen(false);
      }
    }
    if (isCartOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isCartOpen]);


  return (
    <nav className={`nav ${showNav ? 'nav-visible' : 'nav-hidden'} ${menuOpen ? 'open' : ''} ${!isHomePage ? 'nav-black' : ''}`}>

      <Link to='/'>
      <img src={isHomePage ? logo : logoBlack} className='nav-logo' alt='logo' />
      </Link>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {/* <li>
          <Link to='/'>HOME
            <img src={lineSvg} className="nav-hover-line" alt="" />
          </Link>
        </li> */}
        <li>
          <Link to='/category/vintage'>VINTAGE
            <img src={lineSvg} className="nav-hover-line" alt="" />
          </Link>
        </li>
        <li>
          <Link to='/category/clothing'>CLOTHING
            <img src={lineSvg} className="nav-hover-line" alt="" />
          </Link>
        </li>
        <li>
          <Link to='/category/accessories'>ACCESSORIES
            <img src={lineSvg} className="nav-hover-line" alt="" />
          </Link>
        </li>
        <li>
          <Link to='/category/Retroeyewear'>RETRO EYEWEAR
            <img src={lineSvg} className="nav-hover-line" alt="" />
          </Link>
        </li>
        <li>
          <Link to='/category/Custombags'>CUSTOM BAGS
            <img src={lineSvg} className="nav-hover-line" alt="" />
          </Link>
        </li>
        <li>
          <Link to='/category/re-clubbing'>RE-CLUBBING
            <img src={lineSvg} className="nav-hover-line" alt="" />
          </Link>
        </li>
        <li>
          <Link to='/category/curnicielloedition/'>CURNICIELLO EDITION
            <img src={lineSvg} className="nav-hover-line" alt="" />
          </Link>
        </li>
      </ul>

      <ul className='nav-icons'>
        <li>
          {/* <a href='/search' aria-label='Search'>
            <span className='material-symbols-outlined show-on-mobile'>search</span>
          </a> */}
        </li>
        <li>
          {/* <a href='/wishlist' aria-label='Wishlist'>
            <span className='material-symbols-outlined show-on-mobile'>favorite</span>
          </a> */}
        </li>
        {localStorage.getItem('authToken') ? (
          <li onClick={() => {
            localStorage.removeItem('authToken');
            window.location.reload();
          }}>
            <span className='material-symbols-outlined show-on-mobile'>logout</span>
          </li>
          ) : (
          <li>
            <Link to='/login' aria-label='Login'>
              <span className='material-symbols-outlined show-on-mobile'>person</span>
            </Link>
          </li>
          )}

        <li ref={cartIconRef} onClick={toggleCart} style={{ cursor: 'pointer' }}>
          <span className='material-symbols-outlined'>shopping_bag</span>
          {cart.length > 0 && <span className='cart-count'>{cart.length}</span>}
        </li>
        <div className='hamb' onClick={() => setMenuOpen(!menuOpen)}>
          <span className='material-symbols-outlined'>menu</span>
        </div>
      </ul>

      {/* Cart Dropdown */}
      {isCartOpen && (
        <div className='cart-dropdown-wrapper' ref={cartRef}>
          <div className='cart-dropdown'>
            <ShoppingBag />
          </div>
        </div>
      )}
    </nav>
  );
}

export default Nav;
